import React from 'react';
import { Breadcrumb, notification, Modal } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import TablaExpedientes from './TablaExpedientes';
import _ from 'lodash';

import getExpedientes from '../../../graphql/querys/contravenciones/getExpedientes.graphql';
import getTipoExpedientes from '../../../graphql/querys/contravenciones/getTipoExpedientes.graphql';
import getExpedientePorFiltros from '../../../graphql/querys/contravenciones/getExpedientePorFiltros.graphql';
import getCantidadExpedientePorFiltros from '../../../graphql/querys/contravenciones/getCantidadExpedientePorFiltros.graphql';
import deleteExpediente from '../../../graphql/mutations/contravenciones/deleteExpediente.graphql';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

import moment from 'moment';

@compose(
  graphql(getTipoExpedientes, {
    name: 'getTipoExpedientes',
  }),
  graphql(deleteExpediente, {
    name: 'deleteExpediente',
    options: {
      refetchQueries: [{ query: getExpedientes }],
    },
  })
)
class VerTipoExpediente extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
    expediente: {},
    listaFiltrada: null,
    filtroNro: null,
    filtroAnio: null,
    filtroTipo: null,
    filtroOrg: null,
    filtroEstado: null,
    filtroFechaIngreso: null,
    filtroFechaPrescripcion: null,
    pagina: 1,
    cantidadTotal: 0,
    cantidadPorPagina: 10,
    loadingTabla: false,
  };

  componentDidMount() {
    this.buscarCantidadExpedientes();
  }

  buscarCantidadExpedientes = () => {
    this.props.client
      .query({
        query: getCantidadExpedientePorFiltros,
        variables: {
          codigoOrganismo: this.state.filtroOrg,
          tipo: this.state.filtroTipo,
          numero: this.state.filtroNro,
          anio: this.state.filtroAnio,
          estado: this.state.filtroEstado,
          fechaIngresoInicio: this.state.filtroFechaIngresoInicio,
          fechaIngresoFin: this.state.filtroFechaIngresoFin,
          fechaPrescripcion: this.state.filtroFechaPrescripcion,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        this.setState(
          {
            cantidadTotal: res.data.getCantidadExpedientePorFiltros,
          },
          () => {
            this.lanzarconsulta();
          }
        );
      })
      .catch(err => {
        console.log(
          'error a la hora de buscar la cantidad total de paginas en expedientes'
        );
        console.log(err);
        errorService(err, {
          codigoOrganismo: this.state.filtroOrg,
          tipo: this.state.filtroTipo,
          numero: this.state.filtroNro,
          anio: this.state.filtroAnio,
          estado: this.state.filtroEstado,
        });
      });
  };

  onDelete = id => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este expediente?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteExpediente({
            variables: {
              _id: id,
            },
          })
          .then(respuesta => {
            if (respuesta) {
              notification.warning({
                message: 'Expediente eliminado',
                description: 'El expediente fue eliminado correctamente',
              });

              //Lanzamos nuevamente la consulta para que se actualice la lista.
              yo.lanzarconsulta();
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el expediente');
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion del expediente',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  lanzarconsulta = () => {
    this.setState({
      loadingTabla: true,
    });
    this.props.client
      .query({
        query: getExpedientePorFiltros,
        variables: {
          codigoOrganismo: this.state.filtroOrg,
          tipo: this.state.filtroTipo,
          numero: this.state.filtroNro,
          anio: this.state.filtroAnio,
          estado: this.state.filtroEstado,
          fechaIngresoInicio: this.state.filtroFechaIngresoInicio,
          fechaIngresoFin: this.state.filtroFechaIngresoFin,
          fechaPrescripcion: this.state.filtroFechaPrescripcion,
          pagina: this.state.pagina,
          cantidadPorPagina: this.state.cantidadPorPagina,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('LANZANDO CONSULTA: ', res);
        if (res.data.getExpedientePorFiltros) {
          this.setState(
            {
              listaFiltrada: res.data.getExpedientePorFiltros,
              loadingTabla: false,
            },
            () => {
              this.ordenarLista(
                this.state.pagina,
                this.state.cantidadPorPagina
              );
            }
          );
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        notification.error({
          message: 'Error a la hora de buscar los expedientes',
        });
        this.setState({
          loadingTabla: false,
        });
      });
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.lanzarconsulta();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  filtrarPorTipo = async filtro => {
    this.setState(
      {
        filtroTipo: filtro,
      },
      () => {
        this.buscarCantidadExpedientes();
      }
    );
  };
  filtrarPorOrg = async filtro => {
    this.setState(
      {
        ...this.state,
        filtroOrg: filtro,
      },
      () => {
        this.buscarCantidadExpedientes();
      }
    );
  };
  filtrarPorEstado = async filtro => {
    this.setState(
      {
        ...this.state,
        filtroEstado: filtro,
      },
      () => {
        this.buscarCantidadExpedientes();
      }
    );
  };
  filtrarPorNro = async filtro => {
    this.setState(
      {
        ...this.state,
        filtroNro: filtro,
      },
      () => {
        this.buscarCantidadExpedientes();
      }
    );
  };
  filtrarPorAnio = async filtro => {
    this.setState(
      {
        ...this.state,
        filtroAnio: filtro,
      },
      () => {
        this.buscarCantidadExpedientes();
      }
    );
  };

  filtrarPorFechaIngreso = async (inicio, fin) => {
    // console.log('ME LLEGA PARA FILTRAR POR FECHA I: ', filtro);
    this.setState(
      {
        ...this.state,
        filtroFechaIngresoInicio: inicio ? inicio : null,
        filtroFechaIngresoFin: fin ? fin : null,
      },
      () => {
        this.buscarCantidadExpedientes();
      }
    );
  };

  filtrarPorFechaPrescripcion = async cantidadSemanas => {
    // console.log('Cantidad Semanas: ', cantidadSemanas);

    let fechaPrescripcion;
    if (cantidadSemanas || cantidadSemanas === 0) {
      fechaPrescripcion = moment();
      fechaPrescripcion.add(cantidadSemanas, 'w');
    }
    this.setState(
      {
        ...this.state,
        filtroFechaPrescripcion: fechaPrescripcion
          ? fechaPrescripcion.toDate()
          : null,
      },
      () => {
        this.buscarCantidadExpedientes();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaFiltrada,
      [
        expediente => {
          return expediente.numero;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      lista: listaOrdenada,
    });
  };

  render() {
    if (
      this.state.loading ||
      !this.state.listaFiltrada ||
      !this.props.getTipoExpedientes.getTipoExpedientes
    ) {
      return <Loading />;
    }

    let listaExpedientes =
      this.state.listaFiltrada.length > 0 ||
      this.state.filtroTipo ||
      this.state.filtroAnio ||
      this.state.filtroFechaIngreso ||
      this.state.filtroNro ||
      this.state.filtroOrg
        ? this.state.lista
        : [];

    if (!listaExpedientes) {
      listaExpedientes = [];
    }

    let filtrosTipos = [];
    if (this.props.getTipoExpedientes.getTipoExpedientes) {
      _.each(this.props.getTipoExpedientes.getTipoExpedientes, tipo => {
        filtrosTipos.push({
          text: tipo.nombre,
          value: tipo._id,
        });
      });
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Expedientes</Breadcrumb.Item>
          <Breadcrumb.Item>Ver</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          <TablaExpedientes
            expedientes={listaExpedientes}
            history={this.props.history}
            onDelete={this.onDelete}
            filtrarPorTipo={this.filtrarPorTipo}
            filtrarPorAnio={this.filtrarPorAnio}
            filtrarPorNro={this.filtrarPorNro}
            filtrarPorOrg={this.filtrarPorOrg}
            filtrarPorEstado={this.filtrarPorEstado}
            filtrarPorFechaIngreso={this.filtrarPorFechaIngreso}
            filtrarPorFechaPrescripcion={this.filtrarPorFechaPrescripcion}
            tiposExpedientes={filtrosTipos}
            pagina={this.state.pagina}
            tamPagina={this.state.cantidadPorPagina}
            cambiarPagina={this.cambiarPagina}
            cambiarTamañoPagina={this.cambiarTamañoPagina}
            total={this.state.cantidadTotal}
            loadingTabla={this.state.loadingTabla}
          />
        </div>
      </div>
    );
  }
}

export default withApollo(VerTipoExpediente);
